// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"9900da8e","990":"c41927c4"}[chunkId] + ".chunk.js";
};